import './style.scss';
import {Box, FormControl, MenuItem, Select, Typography} from "@mui/material";
import InputPeriodSlider from "../slider/InputPeriodSlider";
import FormHelper from "../../../helpers/FormHelper";
import {ReactComponent as ArrowBackIosNewIcon} from '../../../lib/icons/LoanIcon_arrow.svg';

function Period({label, period, purposeData, handler, className}) {
    purposeData = FormHelper.parsePurposeData(purposeData);
    const handleChange = (event) => {
        handler(event.target.value);
    }
    const handleSlide = (newValue) => {
        handler(newValue);
    }
    const from = purposeData.lp_term_from;
    const to = purposeData.lp_term_to;
    const defaultValue = purposeData.lp_term_default;
    const step = 1;
    let periods = [];
    for (var i = from; i <= to; i++) {
        periods.push(i);
    }
    return <>
        <Box className={className}>
            <Box className="calc-period-head">
                {label && (<Typography variant="h6">{label}</Typography>)}
                <FormControl className="calc-period-wrapper">
                    <Select
                        className="calc-period-input"
                        value={period}
                        onChange={handleChange}
                        displayEmpty
                        inputProps={{'aria-label': 'Without label', 'className': 'calc-period-input-inner'}}
                        MenuProps={{
                            PaperProps: {
                                'className': 'calc-period-popup',
                            },
                        }}
                        IconComponent={ArrowBackIosNewIcon}
                    >
                        {periods.map((item, index) => {
                            return <MenuItem key={'p_' + index} value={item}
                                             className="calc-period-item"
                            >{item} years</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Box>
            <InputPeriodSlider {...{value: period, handler: handleSlide, from, to, defaultValue, step,}}/>
        </Box>
    </>
}

export default Period;